import React from "react";

export default function NotFound() {
    return (
        <div className="my-36 h-full text-7xl font-bold">
            Error 404: Not Found
        </div>
    );
}
